import { Col, Flex, Grid, Row, Typography } from 'antd';
import { FC } from 'react';

import './Footer.scss';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from '@/types/routes';
import { UserRole } from '@/types';
import { Logo } from '@/components/logo';
import CopyRight from '../DefaultLayout/CopyRight';

interface MenuItem {
  key: string;
  label: string;
  path?: string;
  onClick?: () => void;
}

const Footer: FC = () => {
  const navigate = useNavigate();
  const { md } = Grid.useBreakpoint();
  const isAuthenticated = !!localStorage.getItem('accessToken');

  const redirect = (role: UserRole) => {
    if (!isAuthenticated) {
      if (role === UserRole.FRANCHISEE) {
        return navigate(ROUTES.SIGN_UP, {
          state: { role: UserRole.FRANCHISEE },
        });
      }
      if (role === UserRole.CONSULTANT) {
        return navigate(ROUTES.SIGN_UP, {
          state: { role: UserRole.CONSULTANT },
        });
      }
    }

    if (role === UserRole.FRANCHISEE) {
      navigate(ROUTES.FIND_CONSULTANT);
    } else if (role === UserRole.CONSULTANT) {
      navigate(ROUTES.FIND_FRANCHISORS);
    }
  };

  const menu: MenuItem[] = [
    { key: '1', label: 'How It Works', path: '#how-it-works' },
    {
      key: '2',
      label: 'I Am a Franchisor',
      onClick: () => redirect(UserRole.FRANCHISEE),
    },
    {
      key: '3',
      label: 'I Am a Consultant',
      onClick: () => redirect(UserRole.CONSULTANT),
    },
    { key: '4', label: 'Features', path: '#features' },
    { key: '5', label: 'FAQs', path: '#faq' },
  ];

  const handleScroll = (
    event: React.MouseEvent<HTMLAnchorElement>,
    path: string,
  ) => {
    event.preventDefault();
    const targetElement = document.querySelector(path);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className={'landing-footer'}>
      <Row className={'inner-container'}>
        <Col span={24} className={'upper-section'}>
          <Flex
            wrap
            flex={1}
            justify={'space-between'}
            align={'flex-start'}
            gap={40}
          >
            <div className={'contact-mail'}>
              Have questions? Reach out <br />
              at{' '}
              <a href={'mailto:contact@theconsultantexchange.com'}>
                contact@theconsultantexchange.com
              </a>
            </div>

            <nav className={'navigation'}>
              {menu.map((item) => (
                <a
                  className={'navigation-item'}
                  key={item.key}
                  href={item.path}
                  onClick={(e) => {
                    if (item.onClick) {
                      item.onClick();
                    }
                    if (item.path) {
                      handleScroll(e, item.path);
                    }
                  }}
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </Flex>
        </Col>

        <Col span={24} className={'bottom-section'}>
          <Flex
            flex={1}
            justify={'space-between'}
            className={'legal-info'}
            align={'flex-end'}
            wrap
          >
            <Logo
              styles={{
                image: {
                  height: md ? '121px' : '74px',
                  width: md ? '460px' : '280px',
                },
              }}
            />

            <Flex
              className={'legal-info-links'}
              justify={md ? 'space-between' : 'center'}
              wrap
              gap={8}
            >
              <Link
                rel={'noreferrer'}
                target={'_blank'}
                className={'info-link'}
                to={'/privacy-policy'}
              >
                Privacy Policy
              </Link>
              <CopyRight className={'footer-text'} />
            </Flex>
          </Flex>
        </Col>
      </Row>
    </div>
  );
};

export { Footer };
